module.exports = __webpack_public_path__ + "img/direction.3729b91e.png";